import {Customer} from "../../../model/customer/customer";
import {Injectable} from "@angular/core";
import {CCRoles} from "../../../model/security/cc-roles-type";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {FormFieldGroupConfig} from "../../../model/api/form-field-group-config";
import {Trader} from "../../../model/customer/trader";
import {FieldRecord} from "../../../model/api/field-record";
import {CustomerCustomerDataLoadingService} from "./customer-customer-data-loading.service";
import {
  BatchActionCustomerFormComponent
} from "../../../crystal-clear/customer/customer/batch-update-form/batch-action-customer-form.component";
import TYPE = FormFieldConfig.TYPE;
import {BatchUtils} from "../../../utils/batch-utils";

@Injectable({
  providedIn: 'root'
})
export class CustomerCustomerBatchFormConfigService {

  fieldsToUpdate: string[] = [];

  constructor(private dataLoadingService: CustomerCustomerDataLoadingService) {
  }

  public loadConfig(component: BatchActionCustomerFormComponent): FormFieldGroupConfig[] {
    const groupMainFields: FormFieldConfig[] = [
      {
        field: 'ownerId',
        required: true,
        filter: true,
        column: 3,
        type: TYPE.DROPDOWN,
        options: () => this.dataLoadingService.owners,
        changed: event => {
          component.formRecord.ownerId = parseInt(event.value);
          component.formRecord.owner = component.findOptText(this.dataLoadingService.owners, event.value)
          this.dataLoadingService.refreshBrokerageTables(component.formRecord);
        },
        labelCheckbox: component.action == 'update',
        labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
        disabled: (record: any) => component.action == 'update' && !this.fieldsToUpdate.includes('ownerId'),
        validate: record => component.action == 'clone' ? this.validate(component) : ''

      },
      {
        field: 'code',
        required: true,
        column: 4,
        type: TYPE.TEXT,
        focused: true,
        disabled: (record: any) => true
      },
      {
        field: 'name',
        required: true,
        column: 5,
        type: TYPE.TEXT,
        disabled: (record: any) => true
      }
    ];
    if (component.hasRoles(CCRoles.ROLES_CUSTOMER_READ_ADVANCED)) {
      groupMainFields.push(
        {
          field: 'desk',
          column: 3,
          type: TYPE.TEXT,
          labelCheckbox: true,
          labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
          disabled: (record: any) => !this.fieldsToUpdate.includes('desk')
        },
        {
          field: 'salesMan',
          column: 3,
          type: TYPE.TEXT,
          labelCheckbox: true,
          labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
          disabled: (record: any) => !this.fieldsToUpdate.includes('salesMan')
        });
    }
    groupMainFields.push(
      {
        field: 'language',
        filter: true,
        column: 3,
        type: TYPE.DROPDOWN,
        icon: id => id ? ('flag-icon flag-icon-' + id.toLowerCase()) : '',
        options: () => this.dataLoadingService.languages,
        changed: event => component.formRecord.language = event.value.toUpperCase(),
        labelCheckbox: true,
        labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
        disabled: (record: any) => !this.fieldsToUpdate.includes('language')
      },
      {
        field: 'country',
        filter: true,
        column: 3,
        type: TYPE.DROPDOWN,
        icon: id => id ? ('flag-icon flag-icon-' + id.toLowerCase()) : '',
        options: () => this.dataLoadingService.countries,
        changed: event => component.formRecord.country = event.value.toUpperCase(),
        labelCheckbox: true,
        labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
        disabled: (record: any) => !this.fieldsToUpdate.includes('country')
      });

    if (component.hasRoles(CCRoles.ROLES_CUSTOMER_READ_ADVANCED)) {
      groupMainFields.push(
        {
          field: 'email',
          column: 12,
          type: TYPE.TEXT,
          labelCheckbox: true,
          labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
          disabled: (record: any) => !this.fieldsToUpdate.includes('email')
        },
        {
          field: 'confirmationLayout',
          column: 4,
          type: TYPE.TEXT,
          labelCheckbox: true,
          labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
          disabled: (record: any) => !this.fieldsToUpdate.includes('confirmationLayout')
        },
        {
          field: 'lei',
          column: 3,
          type: TYPE.TEXT,
          labelCheckbox: true,
          labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
          disabled: (record: any) => !this.fieldsToUpdate.includes('lei')
        });
    }
    groupMainFields.push(
      {
        field: 'enabled',
        column: 3,
        type: TYPE.CHECKBOX,
        labelCheckbox: true,
        labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
        disabled: (record: any) => !this.fieldsToUpdate.includes('enabled')
      });
    const formConfig: FormFieldGroupConfig[] = [
      {
        group: '',
        fields: groupMainFields
      }];
    if (component.hasRoles(CCRoles.ROLES_CUSTOMER_WRITE_TRADER)) {
      formConfig.push(this.buildTradersConfig(component));
    }
    if (component.hasRoles(CCRoles.ROLES_CUSTOMER_READ_ADVANCED)) {
      formConfig.push({
          group: 'address',
          fields:
            [{
              field: 'address',
              column: 12,
              type: TYPE.TEXT,
              labelCheckbox: true,
              labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
              disabled: (record: any) => !this.fieldsToUpdate.includes('address')
            },
              {
                field: 'zipCode',
                column: 2,
                type: TYPE.TEXT,
                labelCheckbox: true,
                labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
                disabled: (record: any) => !this.fieldsToUpdate.includes('zipCode')
              },
              {
                field: 'town',
                column: 5,
                type: TYPE.TEXT,
                labelCheckbox: true,
                labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
                disabled: (record: any) => !this.fieldsToUpdate.includes('town')
              },
              {
                field: 'stateAddress',
                column: 5,
                type: TYPE.TEXT,
                labelCheckbox: true,
                labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
                disabled: (record: any) => !this.fieldsToUpdate.includes('stateAddress')
              },
            ]
        },
        {
          group: 'invoice_detail',
          fields: [
            {
              field: 'currency',
              column: 5,
              type: TYPE.DROPDOWN,
              filter: true,
              options: () => this.dataLoadingService.currencies,
              icon: id => 'cc-ico',
              iconValue: id => {
                const curr = this.dataLoadingService.currencies && this.dataLoadingService.currencies.find(value => value.id === id) ?
                  this.dataLoadingService.currencies.find(value => value.id === id) : undefined;
                if (curr)
                  return curr.value;
                return '';
              },
              labelCheckbox: true,
              labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
              disabled: (record: any) => !this.fieldsToUpdate.includes('currency')
            },
            {
              field: 'billingDueNbDays',
              column: 2,
              type: TYPE.INTEGER,
              labelCheckbox: true,
              labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
              disabled: (record: any) => !this.fieldsToUpdate.includes('billingDueNbDays')
            },
            {
              field: 'bankAccountId',
              column: 5,
              type: TYPE.DROPDOWN,
              options: () => this.dataLoadingService.bankAccounts,
              labelCheckbox: true,
              labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
              disabled: (record: any) => !this.fieldsToUpdate.includes('bankAccountId')
            },
            {
              field: 'invoiceMail',
              column: 12,
              type: TYPE.TEXT,
              labelCheckbox: true,
              labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
              disabled: (record: any) => !this.fieldsToUpdate.includes('invoiceMail')
            },
            {
              field: 'vat',
              column: 3,
              type: TYPE.CHECKBOX,
              labelCheckbox: true,
              labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
              disabled: (record: any) => !this.fieldsToUpdate.includes('vat')
            },
            {
              field: 'vatNumber',
              column: 3,
              type: TYPE.TEXT,
              labelCheckbox: true,
              labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
              disabled: (record: any) => !this.fieldsToUpdate.includes('vatNumber')
            },
            {
              field: 'brokerageTableName',
              column: 3,
              type: TYPE.DROPDOWN,
              options: () => this.dataLoadingService.brokerageTablesVisibles,
              labelCheckbox: true,
              labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
              disabled: (record: any) => !this.fieldsToUpdate.includes('brokerageTableName')
            },
            {
              field: 'invoiceTemplate',
              column: 3,
              type: TYPE.DROPDOWN,
              options: () => this.dataLoadingService.invoices,
              labelCheckbox: true,
              labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
              disabled: (record: any) => !this.fieldsToUpdate.includes('invoiceTemplate')
            },
          ]
        });
    }
    return formConfig;
  }

  private buildTradersConfig(component: BatchActionCustomerFormComponent): any {
    return {
      group: 'traders',
      // collapsed: true,
      fields: [
        {
          field: 'traders',
          class: 'with-title height-limited filter-table',
          column: 12,
          type: TYPE.TABLEFORMFIELD,
          richFieldConfig: {
            fields: [
              {
                group: '',
                fields: [
                  {
                    field: 'code',
                    label: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Code',
                    type: TYPE.AUTOCOMPLETE,
                    // optionValue: 'id',

                    options: () => this.dataLoadingService.traders.filter(trader => !component.formRecord.traders.some(addedT => addedT.code === trader.id)),
                    leftButton: {
                      icon: 'fa-solid fa-ban',
                      command: (record) => {
                        this.deleteTrader(component, record);
                      },
                      class: 'button-field-small'
                    },
                    changed: (event: FieldRecord<Trader>, event2: Trader) => {
                      if (event && event.value) {
                        event2.initials = event.value.initials
                        event2.description = event.value.description
                      }
                    },
                    disabled: (record: any) => !this.fieldsToUpdate.includes('traders'),
                  },
                  {
                    field: 'initials',
                    label: 'Initials',
                    type: TYPE.TEXT,
                    disabled: (record: any) => !this.fieldsToUpdate.includes('traders'),
                  },
                  {
                    field: 'description',
                    label: 'Description',
                    type: TYPE.TEXT,
                    rightButton: {
                      icon: 'fa-solid fa-ban',
                      command: (record) => {
                        this.deleteTrader(component, record);
                      },
                      class: 'button-field-small'
                    },
                    disabled: (record: any) => !this.fieldsToUpdate.includes('traders'),
                  }]
              },
            ]
          },
          labelCheckbox: true,
          labelCheckboxChanged: (event: FormFieldConfig, event2: any) => BatchUtils.labelCheckboxChanged(this.fieldsToUpdate, component.ccFormDialog, event.field, event2.checked),
          disabled: (record: any) => !this.fieldsToUpdate.includes('traders'),
        }, {
          column: 12,
          type: TYPE.BUTTONS,
          class: 'button-add',
          buttons: [{
            icon: 'fas fa-trash-can',
            class: 'p-button-warning',
            command: event => {
              this.deleteTrader(component);
            },
            disabledFct: record => {
              return !this.fieldsToUpdate.includes('traders') || !component.formRecord || !component.formRecord.traders || component.formRecord.traders.length == 0;
            }
          },
            {
              icon: 'fas fa-plus',
              class: 'p-button-success',
              command: event => {
                this.addNewTrader(component, component.formRecord);
              },
              disabledFct: record => {
                return !this.fieldsToUpdate.includes('traders') || !component.formRecord || component.formRecord.traders &&
                  (component.formRecord.traders.findIndex((trader: Trader) => trader.code == '') >= 0
                    || new Set(component.formRecord.traders.map(t => t.code)).size !== component.formRecord.traders.length);
              }
            }]
        }]
    };
  }

  private deleteTrader(component: BatchActionCustomerFormComponent, trader?: Trader) {
    component.confirmDialog(() => {
      this.delete(component.formRecord, trader);
      component.ccFormDialog.reloadFieldValueMap();
    }, " ", trader ? "Are you sure you want to delete this trader?<br/>This action will only remove the trader from this customer."
      : "Are you sure you want to delete all the traders?<br/>This action will only remove the traders from this customer.");
  }

  private addNewTrader(component: BatchActionCustomerFormComponent, formRecord: Customer) {
    if (formRecord) {
      if (!formRecord.traders) {
        formRecord.traders = [];
      }
      formRecord.traders.push({
        code: "",
        description: "",
        initials: ""
      });
      component.ccFormDialog.reloadFieldValueMap();
    }
  }

  private delete(formRecord: Customer, record?: Trader) {
    if (formRecord) {
      if (record) {
        const existingValueIndex: number = formRecord.traders.findIndex(value => value.code == record.code);
        if (existingValueIndex >= 0) {
          formRecord.traders.splice(existingValueIndex, 1);
        }
      } else {
        formRecord.traders.splice(0);
      }
    }
  }

  validate(component: BatchActionCustomerFormComponent): string {
    return component.originOwnerId == component.formRecord.ownerId ? 'The Owner needs to be changed.' : '';
  }
}
